export default "__VITE_ASSET__Dz1c4Txb__"